import React, { useState } from 'react';

import Card from './components/Card';
import ExpensesFilter from './components/NewExpenses/ExpensesFilter';
import ExpensesList from './components/NewExpenses/ExpensesList';
import ExpensesChart from './components/ExpensesChart';


  
  const Expenses = (props) => {
    const[filteredYear, setFilteredYear] = useState('2020');
  
  const filterChangeHandler = (selectedYear) => {
    setFilteredYear(selectedYear);
  };

  const filteredExpenses = props.items.filter(expense => {
    return expense.date.getFullYear().toString() === filteredYear;
  });

  return (
    <Card className = 'expenses'>
    <ExpensesFilter selected ={filteredYear} 
    onChange = {filterChangeHandler} />
    <ExpensesChart expenses = {filteredExpenses}/>
    <ExpensesList items = {filteredExpenses}/>
    </Card>
  );
};

export default Expenses;